import "./PagemakerInAllCantons.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Einleitung from "./sections/Einleitung";
import KantoneGrid from "./sections/KantoneGrid";
import VertrauensBar from "./sections/VertrauensBar";
import HeroIntroduction from "./sections/HeroIntroduction";
import Footer from "@/reusable_sections/Footer";
export default function PagemakerInAllCantonsPage() {
  return <div>
      <Header />
      <Hero />
      <Einleitung />
      <KantoneGrid />
      <VertrauensBar />
      <HeroIntroduction />
      <Footer />
    </div>;
}